import * as React from "react";
import BtnPulse from "@warda/library-ui/core/BtnPulse";
import WindowMngSets from "@warda/library-ui/layout/WindowMngSets";
import { getTheme } from "@warda/library-ui/theme";
import { getUser } from "@warda/library-ui/utils/getUser";
import { ACT_PANEL } from "./reducer";
import { getActiveFilters, areFiltersUseful, getSlcSaveValues, } from "./utils";
import { MANAGER_GROUPS } from "../AreaProducts/constants";
import { getItemsShared, onCreateSet, onRemoveSet, onSharedUpsert, onSharedRemove, onUpdateSet, } from "../../api/fetchesApiJsonStore";
import getMngSetsSelected from "../../utils/getMngSetsSelected";
import { AggregateTypePrefKeySuffix } from "../../constants/userpref";
import { useContextAggrType, useContextSetUserPref, useContextTenantM2ms, useContextTenantUsers, useContextUserData, useContextUserPref, } from "../Main";
import { useContextDispatchFilters } from "./PanelFilters";
import buildAggregateTypePrefKey from "../AreaProducts/utils/buildAggregateTypePrefKey";
const getManagerPosition = (managerRef) => {
    if (!managerRef.current)
        return [0, 0];
    const { left, top } = managerRef.current.getBoundingClientRect();
    return [left + 30, top];
};
const BtnManager = ({ open, filters, mngSets, context, onError, onChange, levels, enableShared, enableLevels, }) => {
    const userPref = useContextUserPref();
    const userData = useContextUserData();
    const dispatchPanel = useContextDispatchFilters();
    const setPreferences = useContextSetUserPref();
    const aggregateType = useContextAggrType().value;
    const users = useContextTenantUsers();
    const m2ms = useContextTenantM2ms();
    const managerRef = React.useRef(null);
    const keepValue = getSlcSaveValues();
    const { slcSetId } = getMngSetsSelected(context, userPref, mngSets);
    const managerItems = filters.map((f) => ({
        ...f,
        groupId: f.attributeFamily,
    }));
    const filtersRendered = getActiveFilters({
        preferences: userPref,
        context,
        mngSets,
        filters,
    });
    const getManagerChip = React.useCallback((chip, setPayload, shared) => {
        const c = {
            id: chip.id,
            label: chip.label,
            tooltip: chip.tooltip,
            mandatory: chip.mandatory,
            color: getTheme().colors.theme1,
        };
        const chipFiltered = areFiltersUseful([
            {
                ...filters.find((f) => f.id === c.id),
                ...setPayload.items.find((s) => s.id === c.id),
            },
        ]);
        if (!shared && chipFiltered) {
            c.iconRight = "library_add_check";
            c.disabled = true;
            c.tooltip = "⚠️ Unable to remove while the filter is valued";
        }
        return c;
    }, [filters]);
    const onManagerToggle = React.useCallback(() => {
        dispatchPanel({ type: ACT_PANEL.OPEN_MANAGER, open: !open });
    }, [dispatchPanel, open]);
    const onSetsChanged = React.useCallback((context, slcId, sets) => {
        onChange({
            context,
            slcId,
            newId: slcSetId !== slcId,
            sets,
            keepValue,
            updateFilters: true,
        });
    }, [keepValue, onChange, slcSetId]);
    const [positionX, positionY] = getManagerPosition(managerRef);
    const onLevelsUpdate = React.useCallback(async (context, newLevels) => {
        // TODO  devo rimuovere context
        const prefKey = buildAggregateTypePrefKey({
            aggregateType,
            suffix: AggregateTypePrefKeySuffix.filtersSetLevels,
        });
        setPreferences({
            [prefKey]: newLevels,
        });
    }, [aggregateType, setPreferences]);
    const getItemsLevels = React.useCallback(async () => {
        return levels;
    }, [levels]);
    const getMngUser = React.useCallback((userId) => {
        return getUser(userId, users, m2ms);
    }, [m2ms, users]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BtnPulse, { pulse: !filtersRendered.length, cmpRef: managerRef, icon: "filter_list", tooltip: "Open your Filters Sets", onClick: onManagerToggle, selected: open }),
        React.createElement(WindowMngSets, { loading: false, titleText: "Your Filters Sets", titleInfo: [
                "Here you can customize what filters you see in your Filters Panel.",
                "You can create different Sets of Filters for different use cases.",
            ], selectedId: slcSetId, ownerId: userData.userId, context: context, open: open, chipMaxSlc: 25, chipValues: managerItems, chipGroups: MANAGER_GROUPS, sets: mngSets, positionX: positionX, positionY: positionY, onClose: onManagerToggle, getChip: getManagerChip, onSetsChanged: onSetsChanged, onCreateSet: onCreateSet, onRemoveSet: onRemoveSet, onUpdateSet: onUpdateSet, onError: onError, getItemsShared: getItemsShared, onSharedUpsert: onSharedUpsert, onSharedDelete: onSharedRemove, enableShared: enableShared, getItemsLevels: getItemsLevels, onLevelsUpdate: onLevelsUpdate, enableLevels: enableLevels, getUser: getMngUser })));
};
export default BtnManager;
